import { NgModule } from '@angular/core';

import { MasterPerfilAcessoActions } from './master-perfil-acesso.actions';
import { AnteriorAction } from './master-anterior-perfil-acesso.action';
import { ProximoAction } from './master-proximo-perfil-acesso.action';

@NgModule({
  providers: [
      AnteriorAction,
      ProximoAction,
    MasterPerfilAcessoActions
  ]
})
export class MasterPerfilAcessoActionsModule {}
